/* eslint-disable jsx-a11y/alt-text, react/no-unescaped-entities */
import React from 'react'
import { Link } from 'react-router-dom'
import FormFactory from '../../../../components/form/form-factory'

import {
  Header,
  WrapperFAQ,
  Section,
  Container,
  ContainerTerms,
  TermsContainer,
  LogoImage,
} from './styles'
import arrowLeft from '../../../../assets/svg/arrow-left-line.svg'
import FAQ from '../../../../assets/svg/FAQ.svg'

import logoImage from '../../../../assets/png/logo-intro.png'

import IFormPage from '../../../../interfaces/form-page'
import Modal from '../../../../components/modal'

type IProps = any & IFormPage

const TermsContractor = ({
  dataForm,
  onSubmit,
  errorMessage,
  isModalVisible,
  toggleModalVisibility,
  count,
}: IProps): JSX.Element => (
  <>
    <Link to="/signup4/contractor" style={{ textDecoration: 'none' }}>
      <Header>
        <img src={arrowLeft} alt="Voltar" />
        Política de privacidade
      </Header>
    </Link>
    <Container>
      <WrapperFAQ>
        <img src={FAQ} alt="FAQ" />
      </WrapperFAQ>
      <Section>
        É muito importante que você leia os termos da nossa política de
        privacidade antes de concluir o seu cadastro
      </Section>
      <ContainerTerms>
        <TermsContainer>
          <h2>Termos de Uso</h2>
          <p>
            Visando a melhor utilização das ferramentas disponibilizadas pela
            Buscar Médicos Brasil, a empresa apresenta o presente Termos de Uso
            da Plataforma ("Termos de Uso") que deverá ser seguida por todos os
            Usuários que a utilizarem ("Usuários/Usuário"), conforme os termos e
            condições abaixo dispostos.
          </p>
          <p>
            Ao efetuar o primeiro acesso, ler o presente Termos de Uso e, caso
            esteja de acordo com seu teor e conteúdo, em especial, mas sem se
            limitar, à cessão de Privacidade e Proteção de Dados Pessoais,
            deverá aceitar através de seu consentimento por meio do aceite no
            ato de cadastro em nossa Plataforma.
          </p>
          <p>
            De modo geral, ao optar por utilizar nossa plataforma, você concorda
            com as práticas descritas neste termo. Recomendamos você ler
            atentamente nossos Termos e Políticas para garantir uma experiência
            confiável e segura.
          </p>
          <h2>Considerandos</h2>
          <p>
            Considerando que o Usuário Médico é profissional inscrito nos
            quadros do Conselho Federal de Medicina (CFM) e possui interesse em
            receber oportunidades de plantões, consultas e demais serviços
            disponibilizados e oferecidos pelos Usuários Contratantes.
          </p>
          <p>
            O Usuário Contratante é prefeitura ou órgão público municipal,
            estadual ou federal, ou empresa que atua no mercado de saúde e é
            reconhecida como Clínica ou Hospital, público e/ou privado, ou outro
            serviço de saúde e assistência à saúde devidamente cadastrada e
            habilitada nos órgãos regulatórios responsáveis, que possui
            interesse em ter acesso a um catálogo de contatos de médicos para
            contratá-los.
          </p>
          <p>
            A Buscar Médicos Brasil possui os meios necessários para apresentar
            aos Usuários Médicos tais oportunidades ofertadas pelos Usuários
            Contratantes, portanto estabelece o presente Termo de Uso
          </p>
          <h2>Termos de Uso</h2>
          <h3>1. OBJETIVO - USUÁRIO CONTRATANTE</h3>
          <p>
            O presente Termo estabelece as regras e condições de uso da
            plataforma Buscar Médicos Brasil pelos Usuários, sejam eles
            contratantes ou médicos. A Buscar Médicos Brasil disponibiliza uma
            plataforma online onde seus:
          </p>
          <ul>
            <li>
              Usuários Contratantes: podem cadastrar vagas para serviços
              médicos, especificando requisitos, horários, condições de
              trabalho, e outros detalhes relevantes.
            </li>
            <li>
              Usuários Médicos: podem criar perfis profissionais, listar suas
              qualificações, disponibilidades e se candidatar às vagas
              disponíveis nos hospitais.
            </li>
          </ul>
          <h3>1.2 Natureza da Intermediação</h3>
          <p>
            A Buscar Médicos Brasil atua exclusivamente como intermediária,
            facilitando o contato entre médicos e hospitais, e não se
            responsabiliza pela execução dos serviços médicos contratados, pela
            qualidade dos serviços prestados, nem pelos resultados obtidos. A
            relação contratual efetiva para a prestação dos serviços médicos
            ocorre diretamente entre médicos e hospitais, sem qualquer
            responsabilidade solidária ou subsidiária da Buscar Médicos Brasil.
          </p>
          <h3>1.3 Limitações de Responsabilidade</h3>
          <p>
            A Buscar Médicos Brasil não garante a contratação dos Usuários
            Médicos pelos Usuários Contratantes, nem a disponibilidade dos
            médicos para todas as vagas anunciadas. As partes envolvidas devem
            assegurar que todos os requisitos legais e regulamentares aplicáveis
            sejam cumpridos, incluindo, mas não se limitando, às exigências de
            qualificação profissional, licenciamento e conformidade com as
            normas de saúde.
          </p>
          <h3>2. IDENTIFICAÇÃO DA PLATAFORMA</h3>
          <p>
            A Buscar Médicos Brasil, opera por meio de sua empresa PROJETO
            VALORES HUMANOS, pessoa jurídica de direito privado, inscrita no
            CNPJ sob o N° 002790488.00-31, com sede na RUA JORGE MATTAR, 406 A,
            TEOFILO OTONI, CENTRO - MG - CEP 39800078.
          </p>
          <h3>3. MEIOS DE COMUNICAÇÃO</h3>
          <p>
            Nossos meios de comunicação com nossos Usuários e Parceiros são:
          </p>
          <ul>
            <li>contato@buscarmedicosbrasil.com.br</li>
            <li>+55 33 988 301 001</li>
          </ul>
          <p>
            A Buscar Médicos Brasil apenas entrará em contato com os Usuários
            por meio de canais oficiais, não sendo responsável por qualquer
            contato realizado por terceiros sem as devidas autorizações legais.
          </p>
          <h3>4. DAS RESPONSABILIDADES DA PLATAFORMA Buscar Médicos Brasil</h3>
          <p>
            A Buscar Médicos Brasil é uma plataforma de intermediação de
            contatos de profissionais da saúde e Hospitais, Clínicas e
            consultórios, sendo identificados entre os Usuários Médicos e os
            Usuários Contratantes.
          </p>
          <h3>4.1. Proteção e segurança</h3>
          <p>
            Sabendo da relevância e necessidade de segurança que os dados
            pessoais necessitam, a Buscar Médicos Brasil possui extremo cuidado
            com os dados compartilhados por seus Usuários, definindo uma gestão
            segura com procedimentos internos, seguindo requisitos da LGPD e
            demais órgãos reguladores, para resguardar seus usuários. Maiores
            informações poderão ser localizadas em nossas políticas de
            privacidade, também indicadas na cláusula 6.
          </p>
          <h3>4.2. Manutenção e disponibilidade</h3>
          <p>
            A Buscar Médicos Brasil poderá passar por manutenções pontuais ou
            programadas que visam corrigir bugs, falhas ou erros em suas
            funcionalidades, designs, códigos, informações, apresentações ou
            algum outro detalhe não listado. Na hipótese de interrupção do
            serviço oferecido pela Buscar Médicos Brasil devido a manutenção,
            esta emitirá um aviso com antecedência de no mínimo 24 horas, devido
            a emergência da correção, para que seus Usuários possam tomar
            ciência da interrupção.
          </p>
          <h3>4.3. Atualizações</h3>
          <p>
            A Buscar Médicos Brasil poderá passar por atualizações no decorrer
            do tempo em que o Usuário Contratante estiver utilizando a
            plataforma, sendo necessário que seus usuários atualizem o
            aplicativo em seus dispositivos para continuar utilizando. As
            atualizações realizadas terão como objetivo trazer melhorias de
            funcionalidades, acesso e qualidade para seus Usuários e ocorrerão
            em tempo indeterminado.
          </p>
          <h3>4.4. Suporte técnico</h3>
          <p>
            Qualquer problema ou dificuldade encontrada pelo Usuário Médico
            poderá ser tratada através de nosso suporte técnico, através de
            contato realizado por meio do e-mail
            "contato@buscarmedicosbrasil.com.br" ou Tel/WhatsApp "+55 33 988 301
            001".
          </p>
          <p>
            Os pedidos de suporte poderão ser realizados a qualquer momento e
            serão respondidos em até 24 horas após a solicitação de suporte.
          </p>
          <h3>4.6. Conformidade legal</h3>
          <p>
            Em situações em que informações referentes a Buscar Médicos Brasil e
            seus Usuários sejam solicitadas por autoridades competentes a
            colaborar em investigações legais, comprometemo-nos a fazê-lo,
            respeitando sempre os direitos e privacidade dos usuários. A Buscar
            Médicos Brasil revisará regularmente suas práticas operacionais para
            garantir que permaneçam em conformidade com as leis aplicáveis,
            buscando sempre melhorias e atualizações necessárias.
          </p>
          <h3>5. DAS CONDIÇÕES DE USO PELOS USUÁRIOS</h3>
          <p>
            A plataforma Buscar Médicos Brasil poderá apenas ser acessada
            através do link buscarmédicosbrasil.com.br, onde o acesso será
            realizado através de login e senha. A Buscar Médicos Brasil cobrará
            do Usuário, com exceção do Usuário Contratante, que não será
            cobrado, a Taxa de Implantação e Mensalidades correspondentes aos
            valores informados ao Usuário no momento de seu cadastro, conforme o
            plano selecionado.
          </p>
          <p>
            A utilização da plataforma exige acesso à internet, de modo que o
            Usuário é o único responsável pela obtenção, pagamento e manutenção
            de todos os serviços de acesso à internet, plano de dados, tarifas
            e/ou outras taxas, mensalidades e custos associados ao seu acesso e
            uso dos Serviços, bem como pelo software, hardware de computador e
            outros equipamentos necessários para o uso e acesso a plataforma.
          </p>
          <p>
            O Usuário ainda autoriza a Buscar Médicos Brasil a enviar
            comunicados e anúncios de seus serviços, bem como parceiros,
            incluindo, mas não se limitando, ao envio de newsletters, ofertas de
            bens e serviços. A Buscar Médicos Brasil não se responsabiliza,
            direta ou indiretamente, por quaisquer perdas e danos causadas ou
            alegadas que tenham sido causadas ou relacionadas ao uso de qualquer
            conteúdo, bem ou serviço disponível na plataforma ou através do uso
            de qualquer um desses websites, recursos e/ou serviços.
          </p>
          <h3>5.2. Das informações necessárias</h3>
          <p>
            O Usuário Contratante, para utilizar a Buscar Médicos Brasil, terá
            de compartilhar informações necessárias para o seu cadastro. Essas
            informações serão públicas para outros Usuários da plataforma, para
            que estes possam prosseguir com a realização dos devidos contatos e
            contratações.
          </p>
          <ul>
            <li>Nome do perfil - Para identificação do Usuário Médico;</li>
            <li>E-mail e telefone de contato;</li>
            <li>Foto de perfil</li>
            <li>
              Informações gerais do perfil - Informações como descrições sobre a
              atuação da empresa, observações, site institucional e endereço.
            </li>
          </ul>
          <h3>6. RESPONSABILIDADE DOS USUÁRIOS</h3>
          <p>
            O Usuário ao criar sua conta e utilizar as soluções da plataforma
            Buscar Médicos Brasil possui responsabilidades, visando manter o bom
            convívio entre os Usuários e a plataforma, definimos:
          </p>
          <h3>6.1. Responsabilidade pelas informações compartilhadas</h3>
          <p>
            O Usuário da Buscar Médicos Brasil é integralmente responsável pelo
            teor das informações que compartilhar ou disponibilizar na
            plataforma, incluindo seus nomes, contatos, cadastros em órgãos
            regulatórios e qualificações profissionais. Sendo assim, o Usuário
            declara e garante que todo o conteúdo por eles fornecido é
            verdadeiro, preciso e não viola quaisquer leis, regulamentos ou
            direitos de terceiros e reconhece que é o único e exclusivo
            responsável legalmente pelas informações que compartilhar, isentando
            a Buscar Médicos Brasil sobre qualquer responsabilidade decorrente
            da violação de direitos de terceiros ou informação que venha induzir
            outros Usuários a erro. A Buscar Médicos Brasil reserva-se ao
            direito de, a seu exclusivo critério, moderar, editar ou remover
            qualquer informação que viole estes Termos de Uso, leis aplicáveis
            ou que possa ser considerado inadequado. A responsabilidade do
            Usuário pela informação compartilhada na plataforma estende-se mesmo
            após o encerramento de sua conta, mantendo-se sujeitos a ações
            legais decorrentes de violações cometidas durante o período de
            utilização.
          </p>
          <h3>6.2 Responsabilidades do Usuário Médico</h3>
          <p>
            O Usuário Médico possui as seguintes responsabilidades com a
            plataforma:
          </p>
          <ul>
            <li>
              Respeitar os Termos de Uso, devendo cumprir com os requisitos e
              regras de uso da plataforma e as políticas estabelecidas,
              incluindo o respeito entre os usuários e ao pagamento pelos
              serviços contratados dentro da plataforma Buscar Médicos Brasil;
            </li>
            <li>
              Ao interagir com os Usuários Contratantes, deverá respeitar seus
              direitos e garantir um relacionamento profissional e respeitoso,
              cumprindo com os termos, condições e acordos estabelecidos;
            </li>
            <li>
              Prestar serviços de alta qualidade e conforme as expectativas dos
              usuários contratantes, seguindo as melhores práticas e padrões
              profissionais;
            </li>
            <li>
              Manter a confidencialidade de informações sensíveis compartilhadas
              pelos Usuários Contratantes durante a prestação dos serviços,
              protegendo a privacidade e a segurança dos dados de seus
              controladores, pacientes, clientes e funcionários;
            </li>
            <li>
              Responsabilizar-se pelos serviços prestados, mantendo a qualidade
              e a ética em todas as interações com os Usuários Contratantes,
              garantindo que todas as práticas estejam de acordo com as normas
              da profissão.
            </li>
            <li>
              Notificar a Buscar Médicos Brasil imediatamente sobre quaisquer
              mudanças que possam afetar seu cadastro ou sua capacidade de
              prestar serviços, incluindo licenças ou certificações expiradas.
            </li>
            <li>
              Cooperar com a Buscar Médicos Brasil em quaisquer investigações
              sobre comportamentos inadequados ou violações dos Termos de Uso,
              colaborando com informações e esclarecimentos necessários.
            </li>
            <li>
              Garantir que todos os dados e informações pessoais coletados de
              Usuários Contratantes sejam tratados com confidencialidade e em
              conformidade com a legislação de proteção de dados pessoais
              vigente.
            </li>
            <li>
              Não divulgar informações confidenciais de pacientes ou clientes
              sem o devido consentimento, mantendo sempre a privacidade e a
              ética profissional.
            </li>
          </ul>
          <h3>6.3 Responsabilidades do Usuário Contratante</h3>
          <p>
            O Usuário Contratante possui as seguintes responsabilidades com a
            plataforma:
            <ul>
              <li>
                Fornecer informações precisas e atualizadas ao utilizar a
                plataforma, especialmente ao descrever os serviços desejados e
                as condições específicas para sua execução, para que o Usuário
                Médico possa identificá-las com maior transparência;
              </li>
              <li>
                Respeitar os Termos de Uso, devendo cumprir com os requisitos e
                regras de uso da plataforma e as políticas estabelecidas,
                incluindo o respeito entre os usuários e o pagamento pelos
                serviços contratados dentro dos prazos estipulados;
              </li>
              <li>
                Ao interagir com os Usuários Médicos, deverá respeitar seus
                direitos e garantir um relacionamento profissional e respeitoso,
                cumprindo com os termos, condições e acordos estabelecidos;
              </li>
              <li>
                Manter a confidencialidade de informações sensíveis
                compartilhadas pelos Usuários Médico durante a prestação dos
                serviços, protegendo a privacidade e a segurança de seus dados
                pessoais;
              </li>
              <li>
                Cumprir com as ofertas realizadas, reconhecendo que qualquer
                responsabilidade, independente de tempo ou local, não recaia
                sobre a plataforma, momento em que esta é mera intermediadora,
                conforme disposto no ítem 6.4 destes termos;
              </li>
            </ul>
          </p>

          <h3>6.4. Das restrições de uso</h3>
          <p>
            O Usuário, independente de qual for sua licença, ao realizar o
            cadastro no Buscar Médicos Brasil, se compromete expressamente a
            fazer uso adequado das soluções apresentadas, e não usá-los para,
            entre outros:
            <ol>
              <li>
                Disseminar conteúdo que seja criminoso, violento, pornográfico,
                racista, xenófobo, ofensivo, apologia ao terrorismo ou, em
                geral, contrário à lei ou à ordem pública;
              </li>
              <li>
                Ameaçar ou intimidar outra pessoa de qualquer forma, incluindo a
                restrição ou inibição do uso de nossa Plataforma;
              </li>
              <li>
                Introduzir vírus de computador na rede ou executar ações que
                possam alterar, danificar, interromper ou gerar erros ou danos
                aos documentos eletrônicos, dados ou sistemas físicos e lógicos
                da Buscar Médicos Brasil ou de terceiros; além de dificultar o
                acesso de outros usuários ao site e seus serviços através do
                consumo maciço dos recursos de computador através dos quais a
                Buscar Médicos Brasil presta seus serviços;
              </li>
              <li>
                Acessar as contas de e-mail de outros usuários ou áreas
                restritas dos sistemas de computador da Buscar Médicos Brasil ou
                de terceiros e, se for o caso, extrair informações;
              </li>
              <li>
                Violar os direitos de propriedade intelectual ou industrial,
                e/ou de personalidade bem como violar a confidencialidade das
                informações da Buscar Médicos Brasil, de Usuários Médicos ou de
                terceiros não autorizados;
              </li>
              <li>
                Personificar qualquer pessoa, ou atestar falsamente afiliação ou
                representação de qualquer pessoa ou companhia, através do uso de
                endereços de e-mail similares, apelidos, ou a criação de contas
                falsas ou qualquer outro método ou procedimento;
              </li>
              <li>
                Reproduzir, copiar, distribuir, disponibilizar ou qualquer outra
                forma de comunicação pública, transformar ou modificar o
                conteúdo, a menos que a autorização do proprietário dos direitos
                correspondentes esteja disponível ou legalmente permitida;
              </li>
              <li>
                Coletar dados para fins publicitários e enviar publicidade de
                qualquer tipo e/ou comunicações para vendas ou outros fins
                comerciais sem sua solicitação ou consentimento prévio;
              </li>
            </ol>
          </p>

          <h3>6.5. Responsabilidades sobre relações e pagamentos</h3>
          <p>
            Conforme previsto na cláusula 1.2, a Plataforma Buscar Médicos
            Brasil é responsável apenas em apresentar as oportunidades de
            contratação entre os Usuários Médicos e Usuários Contratantes,
            cabendo única e exclusivamente a estes definir como serão realizadas
            suas funções, bem como suas remunerações.
            <br />
            O Usuário Contratante afirma e garante que não cabe à
            Plataforma Buscar Médicos Brasil remunerar os Usuários Médicos,
            sendo esta a responsabilidade do Usuário Contratante, bem como não
            caberá à Buscar Médicos Brasil cobrar outros usuários de suas
            obrigações, funções, responsabilidades e disponibilidades, em
            qualquer tempo ou local, motivo ou circunstância. Também não se
            estabelece, por força deste Termo, qualquer tipo de integração
            societária ou constituição de joint venture entre os Usuários e a
            Buscar Médicos Brasil, quais apenas realizam uma operação comercial,
            de modo que os Usuários são independentes e não constituem como
            empregados da Buscar Médicos Brasil, haja vista que a Plataforma
            funciona apenas como uma facilitadora de ofertas de trabalho. Não se
            estabelece, de igual maneira, qualquer relação trabalhista entre a
            Buscar Médicos Brasil e os Usuários, tendo em vista que a Buscar
            Médicos Brasil é, por meio da plataforma, apenas intermediadora para
            que o Usuário possa ofertar seus serviços e celebrar, caso queira, o
            tipo de contrato que optar por firmar com outros Usuários.
          </p>

          <h3>7. DIREITOS DOS USUÁRIOS</h3>
          <p>
            Além dos direitos de privacidade e proteção de dados previstos nas
            Políticas de Privacidade da plataforma. Dentro dos direitos dos
            Usuários, temos:
          </p>

          <h3>7.1. Dos Usuários Médicos</h3>
          <p>
            O Usuário Médico será chamado por Usuários Contratantes para prestar
            serviços conforme a especialização e disponibilidade própria e
            exigências do Usuário Contratante, possuindo como direitos:
            <ul>
              <li>
                Definir sua própria disponibilidade de dia, local, turno,
                especialidade e setor que deseja atuar;
              </li>
              <li>
                Verificar e analisar as informações do Usuário Contratante que
                lhe enviar ofertas;
              </li>
              <li>
                Liberdade de escolha, podendo aceitar ou recusar a oferta
                realizada pelo Usuário Contratante ao seu livre critério;
              </li>
              <li>
                Editar seu perfil, bem como retificar, excluir, acrescentar ou
                alterar informações e dados pessoais e profissionais;
              </li>
              <li>
                Conversar com o Usuário Contratante que ofertar serviço via chat
                da plataforma.
              </li>
            </ul>
          </p>

          <h3>7.2. Dos Usuários Contratantes</h3>
          <p>
            O Usuário Contratante chamará o Usuário Médico para prestar serviços
            conforme a especialização e disponibilidade própria e exigências do
            Usuário Contratante, possuindo como direitos:
            <ul>
              <li>
                Apresentar informações da empresa e das oportunidades para maior
                visibilidade e confiança;
              </li>
              <li>
                Entrar em contato, conforme as disponibilidades de dia, horário
                e condição, com profissionais credenciados para atuação e
                determinadas especialidades;
              </li>
              <li>
                Conversar com médicos que possui interesse em contratar via chat
                da plataforma;
              </li>
              <li>Analisar os perfis dos Usuários Médicos;</li>
              <li>
                Enviar propostas aos Usuários Médicos conforme suas
                especificações.
              </li>
            </ul>
          </p>

          <h3>8. SANÇÕES POR DESCUMPRIMENTO</h3>
          <p>
            No caso de descumprimento das obrigações previstas neste Termo de
            Uso por qualquer uma das partes, poderão ser aplicadas as seguintes
            sanções, conforme a gravidade da infração:
            <ul>
              <li>
                <strong>Advertência:</strong>
                {' '}
                Para infrações leves, a parte
                infratora receberá uma notificação formal detalhando a infração
                e orientações para correção.
              </li>
              <li>
                <strong>Suspensão Temporária:</strong>
                {' '}
                Para infrações moderadas
                ou reincidência de infrações leves, a parte infratora poderá ter
                seu acesso à plataforma suspenso por um período de até 30
                (trinta) dias.
              </li>
              <li>
                <strong>Rescisão Contratual:</strong>
                {' '}
                Para infrações graves ou
                reincidência de infrações moderadas, a parte infratora poderá
                ter seu contrato rescindido imediatamente, com bloqueio
                definitivo de acesso à plataforma.
              </li>
            </ul>
          </p>

          <h3>8.2 Procedimento de Aplicação de Sanções</h3>
          <p>
            As sanções serão aplicadas após a análise e comprovação do
            descumprimento, garantindo à parte infratora o direito ao
            contraditório e à ampla defesa. O procedimento será o seguinte:
            <ol>
              <li>
                <strong>Notificação:</strong>
                {' '}
                A parte supostamente infratora
                será notificada da infração e terá um prazo de 10 dias úteis
                para apresentar sua defesa.
              </li>
              <li>
                <strong>Análise:</strong>
                {' '}
                A defesa apresentada será analisada
                pela Buscar Médicos Brasil em até 15 dias úteis.
              </li>
              <li>
                <strong>Decisão:</strong>
                {' '}
                A decisão sobre a aplicação da sanção
                será comunicada à parte infratora, detalhando os motivos e as
                evidências consideradas.
              </li>
            </ol>
          </p>

          <h3>8.3 Cancelamento por Iniciativa do Usuário</h3>
          <p>
            Os usuários podem cancelar sua conta e encerrar sua relação com a
            Buscar Médicos Brasil a qualquer momento, mantendo o acesso até o
            fim do seu plano já pago. O cancelamento não implicará na devolução
            de quaisquer valores pagos, salvo disposição em contrário acordada
            entre as partes.
          </p>

          <h3>8.4 Cancelamento por Iniciativa da Plataforma</h3>
          <p>
            A Buscar Médicos Brasil pode cancelar a conta de um usuário nas
            seguintes situações:
            <ul>
              <li>Inatividade por um período superior a 12 (doze) meses;</li>
              <li>
                Repetidas infrações leves que, cumulativamente, prejudiquem o
                bom funcionamento da plataforma;
              </li>
              <li>
                Necessidade de conformidade com alterações legais ou
                regulatórias que tornem impraticável a continuidade da relação
                contratual.
              </li>
            </ul>
          </p>

          <h3>8.5 Efeitos do Cancelamento</h3>
          <p>
            Com o cancelamento da conta, se aplicarão os seguintes feitos:
            <ul>
              <li>
                <strong>Acesso:</strong>
                {' '}
                O usuário perderá imediatamente o
                acesso à plataforma e aos serviços prestados.
              </li>
              <li>
                <strong>Dados:</strong>
                {' '}
                A Buscar Médicos Brasil se compromete a
                excluir os dados pessoais do usuário em conformidade com a LGPD,
                exceto aqueles que precisam ser mantidos por obrigações legais.
              </li>
              <li>
                <strong>Obrigações Pendentes:</strong>
                {' '}
                Quaisquer obrigações
                pendentes, como pagamentos devidos ou serviços ainda não
                prestados, permanecerão em vigor até seu cumprimento integral.
              </li>
            </ul>
          </p>

          <h3>9. PRIVACIDADE E PROTEÇÃO DE DADOS PESSOAIS</h3>
          <p>
            A Buscar Médicos Brasil possui Política de Privacidade elaborada em
            conformidade com a Lei Federal n. 12.965 de 23 de abril de 2014
            (Marco Civil da Internet), com a Lei Federal n. 13.709, de 14 de
            agosto de 2018 (Lei Geral de Proteção de Dados Pessoais).
            <br />
            A Política de Privacidade poderá ser atualizada em decorrência de
            eventual atualização normativa, razão pela qual se convida o usuário
            a consultá-la. As Informações Pessoais Identificáveis serão
            utilizadas nos limites da Política de Privacidade da Buscar Médicos
            Brasil.
            <br />
            O Usuário entende e concorda que a plataforma pode divulgar
            suas informações se requerida a fazê-lo por lei ou por acreditar de
            boa fé que essa divulgação é razoável e necessária para a utilização
            da plataforma.
          </p>
          <h3>10. DISPOSIÇÕES GERAIS</h3>
          <p>
            A Buscar Médicos Brasil não se responsabiliza pelas falhas ocorridas
            nos sistemas de celular, dispositivo, computador, internet, ou
            qualquer outro que o Usuário Contratante venha a utilizar para
            acessar a plataforma.
          </p>
          <p>
            Todo o conteúdo e informações constantes na Plataforma, inclusos,
            mas sem se limitar a, marcas, logotipos, imagens, fotografias,
            nomes, são de propriedade da Buscar Médicos Brasil e não podem ser
            copiados, reproduzidos, publicados ou transferidos sem autorização
            expressa sob pena de ser o infrator responsabilizado civil e
            criminalmente, nos termos da legislação aplicável aos direitos
            autorais e de propriedade intelectual.
          </p>
          <p>
            Esses termos e condições poderão ser modificados a qualquer tempo, a
            critério único e exclusivo da Buscar Médicos Brasil. Nesta hipótese,
            o Usuário deverá, no acesso subsequente à alteração, ler a nova
            versão dos respectivos Termos de Uso da plataforma Buscar Médicos
            Brasil e consignar o seu livre e expresso consentimento, como
            condição à utilização da referida plataforma.
          </p>
          <p>
            Este Termo vigorará por prazo indeterminado, podendo ser cancelado a
            qualquer momento, por decisão unilateral da Buscar Médicos Brasil.
          </p>
          <p>
            O Usuário, ao criar sua conta, obrigatoriamente deverá aceitar os
            termos de uso. Ao utilizar as soluções oferecidas pela Buscar
            Médicos Brasil o Usuário automaticamente concorda com estes termos
            de uso e políticas de privacidade.
          </p>
          <p>
            Qualquer litígio que eventualmente surja a partir das regras
            estabelecidas no presente Termo deverá ter por foro competente o
            Foro da Cidade de Teófilo Otoni/MG, renunciando as partes, de comum
            acordo, a qualquer outro, por mais vantajoso que seja.
          </p>
        </TermsContainer>
      </ContainerTerms>
      <FormFactory
        data={dataForm}
        onSubmit={onSubmit}
        submitErrorMessage={errorMessage}
      />
      <Modal
        isVisible={isModalVisible}
        toggleVisibility={toggleModalVisibility}
        content={{
          title: 'Confirme seu Email',
          component: () => (
            <div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}
              >
                <LogoImage src={logoImage} alt="Logo" />
              </div>
              <br />
              Cadastro concluído, por favor, verifique o link enviado para o seu
              email e clique para confirmar seu endereço de email.
              <br />
              <br />
              Você será redirecionado em
              {' '}
              <strong>{count}</strong>
              {' '}
              segundos.
            </div>
          ),
          width: '80%',
        }}
        hasHeader
      />
    </Container>
  </>
)

export default TermsContractor
